export default ({ dropdown }) => ({
  dark: {},
  header: {
    '&$dark': {
      color: dropdown.dark.optionHeader
    },
    color: dropdown.optionHeader,
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: '30px',
    textTransform: 'uppercase',
    padding: [4, 12, 4, 15],
    paddingLeft: ({ depth }) => 15 * depth
  }
});
